<div class="filters">
  @for (filter of tableContext.iteratableFilters(); let i = $index; track
  trackBy(filter[0])) {
  <app-select
    [options]="getOptions(filter[1])"
    [type]="'check'"
    size="sm"
    [name]="filter[0]"
    (getCheckedItems)="handleFilterDataChange($event, filter[0])"
    (getSelectedOption)="handleOptionSelected($event, filter[0])"
  ></app-select>
  }
</div>
